import React from "react";
import { Container } from "react-bootstrap";
import Particle from "./Particle";

const legalStyle = {
  padding: "50px 20px",
  textAlign: "left",
  backgroundColor: "rgba(255, 255, 255, 0.95)",
  borderRadius: "10px",
  marginTop: "120px",
  color: "#333",
};

const faqItemStyle = { marginBottom: "1.2em" };
const faqLabelStyle = { display: "block", marginBottom: "0.3em", color: "#222" };

function SupportHootshot() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <div className="legal-content" style={legalStyle}>
          <h1 style={{ textAlign: "center", marginBottom: "10px", color: "#2c3e50" }}>
            HootShot
          </h1>
          <p style={{ textAlign: "center", color: "#666", marginBottom: "30px" }}>
            Support & Help
          </p>

          <h3>About HootShot</h3>
          <p>
            HootShot is a menu-bar screenshot, annotation, and image utility for macOS.
            Capture an area, a window, or your full screen; mark up with arrows, rectangles, blur,
            and text; extract text with OCR; pick colors; and resize or export in PNG, JPEG, HEIC, or TIFF.
            No account is required — your captures and settings stay on your device.
          </p>

          <h3>Frequently Asked Questions</h3>

          <div style={faqItemStyle}>
            <strong style={faqLabelStyle}>Hotkeys aren't working. What should I check?</strong>
            HootShot needs <em>Accessibility</em> permission to listen for global hotkeys. Open
            System Settings &gt; Privacy &amp; Security &gt; Accessibility and make sure HootShot
            is enabled. You may need to quit and re-open the App after granting access.
          </div>

          <div style={faqItemStyle}>
            <strong style={faqLabelStyle}>I can't capture my screen. What's wrong?</strong>
            macOS requires <em>Screen Recording</em> permission for any screenshot tool. Open
            System Settings &gt; Privacy &amp; Security &gt; Screen Recording and enable HootShot.
            After enabling, restart HootShot.
          </div>

          <div style={faqItemStyle}>
            <strong style={faqLabelStyle}>How do I capture an area, window, or full screen?</strong>
            Click the HootShot icon in the menu bar and choose <strong>Select Area</strong>,
            <strong> Capture Window</strong>, or <strong>Full Screen</strong>. Each mode has a
            keyboard shortcut shown next to it in the menu — you can trigger captures without
            leaving the keyboard.
          </div>

          <div style={faqItemStyle}>
            <strong style={faqLabelStyle}>How does OCR (Extract Text) work?</strong>
            HootShot uses Apple's on-device Vision framework to recognize text in your captures.
            Image data is processed locally on your Mac and is not sent to any server.
          </div>

          <div style={faqItemStyle}>
            <strong style={faqLabelStyle}>Which export formats are supported?</strong>
            PNG, JPEG, HEIC, and TIFF. You can also resize to 25%, 50%, 75%, or pick a preset
            before exporting.
          </div>

          <div style={faqItemStyle}>
            <strong style={faqLabelStyle}>How do I change the language?</strong>
            HootShot supports English, Deutsch, Español, and Türkçe. The interface follows your
            macOS system language by default; you can override it in HootShot's Settings.
          </div>

          <div style={faqItemStyle}>
            <strong style={faqLabelStyle}>How do I request a refund?</strong>
            Mac App Store purchases are handled by Apple. You can request a refund through{" "}
            <a href="https://reportaproblem.apple.com" target="_blank" rel="noreferrer">
              reportaproblem.apple.com
            </a>.
          </div>

          <div style={faqItemStyle}>
            <strong style={faqLabelStyle}>How do I delete my data?</strong>
            HootShot does not store any personal data on our servers. All captures and settings
            are local to your Mac — uninstall the App and remove its data from
            <code> ~/Library/Containers</code> (or use a full-uninstall utility) to clear everything.
          </div>

          <hr style={{ margin: "30px 0" }} />

          <h3>Contact Support</h3>
          <p style={{ textAlign: "center" }}>
            Have a question, found a bug, or want to suggest a feature?
          </p>
          <p style={{ textAlign: "center" }}>
            <a href="mailto:sozdemircim@gmail.com">sozdemircim@gmail.com</a>
          </p>
        </div>
      </Container>
    </Container>
  );
}

export default SupportHootshot;
